module.exports = __webpack_public_path__ + "img/13.48c66bb2.png";